var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activated-icon"},[_c('el-tooltip',{attrs:{"content":_vm.tooltipText}},[_c('i',{class:_vm.activatedIcon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }